module.exports = {"100x100": __webpack_public_path__ + "images/highlight-100x100.png"};